<table class="w-p-100">
  <tr>
    <td>
      <particle-file-selector
        [(file)]="fileToUploadCompareFrom"
        data-copilot="compare-file-first"
        class="flex flex-row"
        [legend]="'Document1 (.pdf)'"
        [acceptedTypes]="'.pdf'"
        [required]="true"
        [showDriveOption]="!hasKPMGFeature"
        (change)="handleFileInputFrom()">
      </particle-file-selector>
    </td>
    <td>
      <particle-file-selector
        [(file)]="fileToUploadCompareTo"
        data-copilot="compare-file-second"
        class="flex flex-row"
        [legend]="'Document2 (.pdf)'"
        [acceptedTypes]="'.pdf'"
        [required]="true"
        [showDriveOption]="!hasKPMGFeature"
        (change)="handleFileInputTo()">
      </particle-file-selector>
    </td>
  </tr>
  <div *ngIf="!isCheckFileFormat" style="color: red;" class="m-b-10">
    <label>Invalid File Type(Accepted Format: .pdf).</label><span>*</span>
  </div>
  <tr>
    <td>
      <mat-checkbox [(ngModel)]="isFileScannedFrom" data-copilot="compare-checkbox-first-scanned"
      >Treat as scanned
      </mat-checkbox
      >
    </td>
    <td>
      <mat-checkbox [(ngModel)]="isFileScannedTo" data-copilot="compare-checkbox-second-scanned"
      >Treat as scanned
      </mat-checkbox
      >
    </td>
  </tr>
  <tr>
    <td>
      <mat-form-field appearance="outline" class="w-p-100" *ngIf="isFileScannedFrom">
        <mat-label>Select a Language</mat-label>
        <mat-select placeholder="Select a Language" [(ngModel)]="fromLanguage" data-copilot="compare-select-first-language">
          <mat-option
            *ngFor="let language of taxformsSupportiveLanguage"
            [value]="language.code"
            [attr.data-copilot]="'compare-option-first-' + language.code"
          >
            {{ language.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </td>
    <td>
      <mat-form-field appearance="outline" class="w-p-100" *ngIf="isFileScannedTo">
        <mat-label>Select a Language</mat-label>
        <mat-select placeholder="Select a Language" [(ngModel)]="toLanguage" data-copilot="compare-select-second-language">
          <mat-option
            *ngFor="let language of taxformsSupportiveLanguage"
            [value]="language.code"
            [attr.data-copilot]="'compare-option-second-' + language.code"
          >
            {{ language.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </td>
  </tr>
</table>
<div>
  <mat-form-field class="w-p-100" floatPlaceholder="always" floatLabel="always" appearance="outline">
    <mat-label>Storage *</mat-label>
    <input matInput placeholder="Input" style="display: none"
           particleAnalytics
           analyticsCategory="choice-filter-modal-item-editor"
           analyticsAction="entity-scope-input">
    <mat-radio-group [(ngModel)]="storageSettings">
      <mat-radio-button [disabled]="hasKPMGFeature" [value]="storageOptions.Stored" class="m-b-12" data-copilot="compare-radio-stored">
        <div class="flex flex-col">
          <span>
            I want to store these documents in Orbitax
          </span>
          <div class="hint flex flex-col">
            <div class="flex flex-row">
              Your documents will be available to view, manage and share
              with your contacts via the Translation tool at any point.
            </div>
          </div>
        </div>
      </mat-radio-button>
      <mat-radio-button [value]="storageOptions.NonStored" class="m-b-12" data-copilot="compare-radio-non-stored">
        <div class="flex flex-col">
          <span>
            I do not want to store these documents in Orbitax
          </span>
          <div class="hint flex flex-col">
            <div *ngIf="hasKPMGFeature" class="flex flex-row">
              Your document will be available to download for 15 minutes
              before being removed permanently from the system.
            </div>

            <div *ngIf="!hasKPMGFeature" class="flex flex-row">
              Your document will be available to download for 24 hours
              before being removed permanently from the system.
            </div>
          </div>
        </div>
      </mat-radio-button>
    </mat-radio-group>
  </mat-form-field>
</div>
